import React, { useState } from "react"
import {
	Typography,
	Grid,
	Tab,
	Tabs
} from "@material-ui/core"

import {
	Breadcrumb
} from "@/components"

import { integrationInfo } from "@/utils/integration"

import RDStationMarketingPlugin from "@/pages/Admin/Plugins/RDStationPlugin/RDStationMarketingPlugin"
import RDStationCRMPlugin from "@/pages/Admin/Plugins/RDStationPlugin/RDStationCRMPlugin"

import HardCoded from "@/services/HardCoded"

import useStyles from "@/pages/Admin/Plugins/RDStationPlugin/styles"

type RDStationPluginTabType = "marketing" | "crm"

type RDStationPluginTab = {
	title: string
	type: RDStationPluginTabType
}

const RDStationPlugin = () => {
	const canUseRDStationCRM = HardCoded.checkFeatureFlag("canUseRDStationCRM")

	const RD_STATION_PLUGIN_TABS: RDStationPluginTab[] = [
		{
			title: "RD STATION MARKETING",
			type: "marketing"
		},
		...(canUseRDStationCRM ? [{
			title: "RD STATION CRM",
			type: "crm" as RDStationPluginTabType
		}] : [])
	]

	const [currentRDStationPluginTabType, setCurrentRDStationPluginTabType] = useState<RDStationPluginTabType>(RD_STATION_PLUGIN_TABS[0]?.type)

	const classes = useStyles()

	const handleChangeCurrentRDStationPluginTabType = (type: RDStationPluginTabType): void => {
		setCurrentRDStationPluginTabType(type)
	}

	return (
		<Grid
			container
			direction="column"
			spacing={3}
		>
			<Grid item xs={12}>
				<Grid
					alignItems="center"
					justifyContent="space-between"
					container
				>
					<Typography
						variant="h4"
						color="textPrimary"
						className={classes.breadcrumb}
					>
						<Breadcrumb
							data={[
								{ name: "Plugins", pathname: "/admin/plugins" },
								{ name: "RD Station", pathname: "/admin/plugins/rd-station" }
							]}
						/>
					</Typography>

					<img
						src={integrationInfo.RDStation?.logo}
						alt="RD Station logo"
						className={classes.logoImg}
					/>
				</Grid>
			</Grid>

			<Grid item xs={12}>
				<Grid container direction="column" spacing={3}>
					<Grid item xs={12}>
						<Tabs
							color="primary"
							value={currentRDStationPluginTabType}
							className={classes.tabs}
							onChange={(_, value) => handleChangeCurrentRDStationPluginTabType(value)}
							classes={{
								indicator: classes.tabIndicator
							}}
						>
							{RD_STATION_PLUGIN_TABS.map(RDStationPluginTab => (
								<Tab
									key={RDStationPluginTab.type}
									label={RDStationPluginTab.title}
									value={RDStationPluginTab.type}
									className={classes.tab}
								/>
							))}
						</Tabs>
					</Grid>

					<Grid item xs={12}>
						{currentRDStationPluginTabType === "marketing" && <RDStationMarketingPlugin />}
						{currentRDStationPluginTabType === "crm" && <RDStationCRMPlugin />}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default RDStationPlugin
